var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loaded)?_c('Tabs',{ref:"Tabs",attrs:{"data":_vm.data}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }